import { formatBytes } from "./formatBytes";
import { maxFileSize } from "../prefs";

export const validateFileSize = file => {
  if (file.size > maxFileSize) {
    const formattedByteString = formatBytes(file.size);
    const errorMessage = `Please select a file smaller than 10MB. File size: ${formattedByteString}`;
    return errorMessage;
  }

  return "";
};

export const validateFileType = (file, pattern) => {
  const validFileType = pattern.test(file.name);
  return validFileType;
};



// WEBPACK FOOTER //
// ./src/utils/validation.js